<template>
    <form method="post" @submit.prevent="submitMethod" :action="action">
        <SkippableCaptcha v-if="captchaField && canSkipCaptcha" ref="captcha" @verify="ajaxSubmit"></SkippableCaptcha>
        <Captcha v-if="captchaField && !canSkipCaptcha" ref="captcha" @verify="ajaxSubmit"></Captcha>

        <input type="hidden" :name="captchaField" v-model="captchaCode" v-if="captchaField" />

        <slot :is-loading="isLoading" :errors="errors" :success="success"></slot>
    </form>
</template>

<script>
    import { submitYiiForm } from '../../helpers/yii';
    import SkippableCaptcha from "./SkippableCaptcha";
    import Captcha from "./Captcha";

    export default {
        name: 'AjaxForm',

        components: {Captcha, SkippableCaptcha},

        props: {
            action: {type: String, required: true},
            captchaField: String,
            canSkipCaptcha: {type: Boolean, default: false},
        },

        data() {
            return {
                isLoading: false,
                errors: {},
                success: false,
                captchaCode: '',
            };
        },

        computed: {
            submitMethod() {
                return this.captchaField ? this.captchaSubmit : this.submit;
            },
        },

        methods: {
            captchaSubmit(e) {
                this.$refs.captcha.$once('verify', code => {
                    this.captchaCode = code;
                    this.$nextTick(() => {
                        this.submit(e);
                    });
                });

                this.$refs.captcha.execute();
            },
            submit(e) {
                this.isLoading = true;
                this.success = false;

                submitYiiForm(this.action, e.target)
                    .then(response => {
                        if (typeof response.data === 'string') {
                            this.errors = {general: response.data};
                        } else if (typeof response.data === 'object') {
                            this.errors = response.data;
                        } else if (response.data) {
                            this.errors = {};
                            this.success = true;
                        }
                    })
                    .catch(err => {
                        this.errors.general = err;
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            }
        },
    };
</script>
